export default __webpack_public_path__ + "locales/es/ChangePhoneDialog.json?hash=bfe61eb77c242f2cc6b5e1b72eaeec32";